<div class="header">
  <span class="title">Privacy Editor</span>
  <!-- <mat-checkbox class="example-margin">Select all</mat-checkbox> -->
  <span></span>
  <div>
    <span class="tip">Highlight areas you wish to omit from the document for privacy reasons.</span>
    <div class="icons">
      <mat-icon (click)="disableEditor()" *ngIf="cropperEnabled$ | async" class="tick-crop" svgIcon="tick_green"></mat-icon>
      <mat-icon (click)="undo()" class="undo-icon" svgIcon="undo"></mat-icon>
      <mat-icon class="enabled-cropper" (click)="disableEditor()"
        *ngIf="userRole!='Realtor' && cropperEnabled$ | async; else userRole!='Realtor' &&  cropperDisabled"
        svgIcon="enable_crop"></mat-icon>
      <ng-template #cropperDisabled>
        <mat-icon (click)="enableCropper()" svgIcon="disable_crop"></mat-icon>
      </ng-template>

      <mat-icon (click)="disableEditor()" *ngIf="rectangleRendererEnabled$ | async; else notEditable"
        svgIcon="create_white"></mat-icon>
      <mat-icon (click)="disableEditor()"
        *ngIf="userRole!='Realtor' && rectangleRendererHighlighterEnabled$ | async; else userRole!='Realtor' && notEditableHighlighter"
        class="highlighterIcon" style="background-color: #ffff00;" svgIcon="highlighter"></mat-icon>

      <ng-template #notEditable>
        <mat-icon (click)="enableRectangleRenderer()" svgIcon="create_black"></mat-icon>
      </ng-template>

      <ng-template #notEditableHighlighter>
        <mat-icon (click)="enableRectangleRendererHighlighter()" class="highlighterIcon" svgIcon="highlighter">
        </mat-icon>
      </ng-template>

    </div>
  </div>
</div>

<arb-pdf-editor *ngIf="isPdf" [file]="data" [rendererType$]="rendererType$" [undo$]="undo$" [crop$]="crop$"
  (filesChange)="onFilesChange($event)" (pageChanged)="onPageChanged()">
</arb-pdf-editor>

<arb-image-editor *ngIf="!isPdf" [rendererType$]="rendererType$" [file]="data" [undo$]="undo$" [crop$]="crop$"
  (filesChange)="onFilesChange($event)">
</arb-image-editor>

<div class="footer">
  <mat-checkbox [formControl]="agreementControl" color="primary" class="wmaccess-pdf-editor-checkbox">
    <!-- <span class="agreement-text">I certified that this document has all private information redacted.</span> -->
    <span class="agreement-text">Please ensure this document has all private information redacted.</span>
  </mat-checkbox>
  <div class="buttons">
    <button mat-dialog-close mat-flat-button>Cancel</button>
    <button [disabled]="!((allowSave$ | async) && !!files.length)" (click)="save()" mat-flat-button color="primary">
      Save
    </button>
  </div>
</div>